const inputConfig = {
  token: {
    controlHeight: 45, // Высота больших элементов
  },
}

export default inputConfig
